// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1YXtD","orderText":"VGlQ2","banner":"_2C077","blockLastOrder":"mLYCS","reOrder":"_1R5rR","orderData":"_3vMOQ","blockButton":"apndg"};